/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/389-mail2': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M13.333 0H2.667A2.675 2.675 0 000 2.667v10.666C0 14.801 1.2 16 2.667 16h10.666A2.674 2.674 0 0016 13.333V2.667C16 1.2 14.8 0 13.333 0zm0 2c.125 0 .243.036.344.099L7.999 6.793 2.322 2.099A.648.648 0 012.666 2h10.666zM2.667 14a.654.654 0 01-.089-.006l3.525-4.89-.457-.457L2 12.293V2.744L8 10l6-7.256v9.549l-3.646-3.646-.457.457 3.525 4.89a.65.65 0 01-.088.006H2.668z"/>'
  }
})
